import type { OrcamentoEventoResponse } from '@triade/contracts';
import { formatarDataHora } from '@/lib/format';
import { ROTULO_STATUS } from '../tipos';

const rotuloSituacao = (s: string): string => (s in ROTULO_STATUS ? ROTULO_STATUS[s as keyof typeof ROTULO_STATUS] : s);

/** Rotulo de cada evento da linha do tempo (texto da tela; o evento e o que a API gravou). */
export function rotuloEvento(e: OrcamentoEventoResponse): string {
  const v = e.versaoNumero;
  switch (e.evento) {
    case 'VERSAO_CRIADA':
      return v ? `Versão ${v} criada como rascunho` : 'Versão criada como rascunho';
    case 'VERSAO_ENVIADA':
      return v ? `Versão ${v} enviada ao cliente (congelada)` : 'Versão enviada ao cliente';
    case 'VERSAO_APROVADA':
      return v ? `Versão ${v} aprovada` : 'Versão aprovada';
    case 'VERSAO_DESCARTADA':
      return v ? `Rascunho da versão ${v} descartado` : 'Rascunho descartado';
    case 'SITUACAO':
      return e.de ? `Situação: ${rotuloSituacao(e.de)} → ${rotuloSituacao(e.para)}` : `Situação: ${rotuloSituacao(e.para)}`;
  }
}

/** Linha do tempo (eventos[] do detalhe): situacoes do pipeline e o ciclo das versoes, do mais novo ao mais antigo. */
export function LinhaDoTempo({ eventos }: { eventos: OrcamentoEventoResponse[] }) {
  if (eventos.length === 0) return <p className="text-small text-ink-muted">Nenhum evento registrado.</p>;
  return (
    <ol aria-label="Linha do tempo" data-testid="linha-tempo" className="m-0 flex list-none flex-col gap-3 p-0">
      {eventos.map((e) => (
        <li key={e.id} data-testid="evento" data-evento={e.evento} className="border-l-2 border-border pl-3 text-small">
          <div className="font-medium text-ink">{rotuloEvento(e)}</div>
          <div className="text-caption text-ink-muted">
            {formatarDataHora(e.createdAt)}
            {e.usuarioNome ? ` · ${e.usuarioNome}` : ''}
          </div>
          {e.motivo && <p className="mt-0.5 text-ink-body">{e.motivo}</p>}
        </li>
      ))}
    </ol>
  );
}
